import { useTranslation } from "react-i18next";
import { PropertyDetailsObj } from "../../Models/PropertyDetailsObj";


const CountryDetails: React.FunctionComponent<{ property: PropertyDetailsObj }> = (props) => {

    const { t } = useTranslation();

    return (
        props.property?.content?.titleDeed && props.property?.content?.Permit && <div className="row marg-left-5  mt-4">
            <div className="col-md-6 mb-4">
                <div className="row">
                    <div className="col-12">
                        <h3 className="title-20  mb-4 color-black line-height-30 mt-4">{t("generateDescTitle.country")} </h3>
                    </div>
                    <div className="col-3">
                        {props.property?.content?.titleDeed && <p className="para-16 bold-600 color-balck mb-3">{t("propertyDetails.titleDeed")}:</p>}
                        {props.property?.content?.Permit && <p className="para-16 bold-600 color-balck mb-3">{t("propertyDetails.Permit")}:</p>}
                        {props.property?.content?.buildYear && <p className="para-16 bold-600 color-balck mb-3">{t("propertyDetails.buildYear")}:</p>}
                        {props.property?.content?.floor && <p className="para-16 bold-600 color-balck mb-3 ">{t("propertyDetails.floor")}:</p>}
                    </div>
                    <div className="col-2">
                        <p className="para-14 color-727272 bold-500 mb-3 ">{props.property?.content?.titleDeed}</p>
                        <p className="para-14 color-727272 bold-500 mb-3">{props.property?.content?.Permit}</p>
                        <p className="para-14 color-727272 bold-500 mb-3">{props.property?.content?.buildYear}</p>
                        <p className="para-14 color-727272 bold-500 mb-3">{props.property?.content?.floor}</p>
                    </div>
                    <div className="col-4">
                        {props.property?.content?.availableForm && <p className="para-16 bold-600 color-balck mb-3">{t("propertyDetails.availableForm")} <span className="color-0-4 para-14">({t("generateDescTitle.optional")})</span></p>}
                        {props.property?.content?.deliveryDate && <p className="para-16 bold-600 color-balck mb-3">{t("propertyDetails.deliveryDate")} <span className="color-0-4 para-14">({t("generateDescTitle.optional")})</span></p>}
                        {props.property?.content?.paymentCheques && <p className="para-16 bold-600 color-balck mb-3">{t("propertyDetails.paymentCheques")} <span className="color-0-4 para-14">({t("generateDescTitle.optional")})</span></p>}
                    </div>
                    <div className="col-3">
                        <p className="para-14 color-727272 mb-3 ">{props.property?.content?.availableForm}</p>
                        <p className="para-14 color-727272 mb-3 ">{props.property?.content?.deliveryDate}</p>
                        <p className="para-14 color-727272 mb-3 ">{props.property?.content?.paymentCheques}</p>
                    </div>
                </div>
            </div>

            <div className="col-md-6 div-Qr-code mb-4">
                <div className="">
                    <img src={"/assets/images/icons/Qr-code.png"} className="img-qr-code" alt="Qr Code" />
                    <h3 className="para-16 bold-700 color-746AFF text-center">{t("propertyDetails.listingQRCode")}</h3>
                </div>
            </div>
        </div>

    )
}

export default CountryDetails;